import { render } from "./EditingMetadata.vue?vue&type=template&id=517e7ad9&scoped=true"
import script from "./EditingMetadata.vue?vue&type=script&lang=js"
export * from "./EditingMetadata.vue?vue&type=script&lang=js"

import "./EditingMetadata.vue?vue&type=style&index=0&id=517e7ad9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-517e7ad9"

export default script